<template>
  <div>
    <sui-button color="blue" icon="arrow left" label-position="left" @click="goBack($event, '/')">{{$t('btnBack')}}</sui-button>
    <sui-segment raised>
      <sui-container text-align="center">
        <h2 is="sui-header">{{$t('labelImprint')}}</h2>
        <h3 is="sui-header">Angaben gem&auml;&szlig; &sect; 5 TMG</h3>
        LAN1 Hotspots GmbH<br />
        Gau&szlig;stra&szlig;e 158<br />
        D-22765 Hamburg<br />
        <br />
        Tel.: 	+49 (0)40 317 66 66 0<br />
        Fax.: 	+49 (0)40 317 66 66 33<br />
        E-mail: info[at]lan1.de<br />
        Web:    www.lan1.de<br />
        <br />
        Sitz der Gesellschaft: Hamburg<br />
        HRB 118700 - Amtsgericht Hamburg<br />
        Gesch&auml;ftsf&uuml;hrer: J&ouml;rg H&uuml;mmer<br />
        <br />
        <h3 is="sui-header">Alternative Streitbeilegung in Verbrauchersachen</h3>
        Gem. Art. 14 Abs. 1 ODR-VO weisen wir auf die Plattform der Europ&auml;ischen Kommission zur Online Streitbeilegung (OS) f&uuml;r
        Verbraucher hin: <a href="http://ec.europa.eu/consumers/odr/" target="_blank">http://ec.europa.eu/consumers/odr/</a>.<br />
        Des Weiteren informieren wir Sie gem&auml;&szlig; &sect; 36 Abs. 1 Nr. 1 VSBG dar&uuml;ber, dass wir zu einer Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht verpflichtet sind und hierf&uuml;r nicht zur Verf&uuml;gung stehen.
      </sui-container>
    </sui-segment>
  </div>
</template>

<script>
  export default {
    name: 'Imprint',
    metaInfo() {
      return {
        title: this.$t('labelImprint'),
        meta: [
          /*{ vmid: 'description', name: 'description', content: this.data.content }*/
        ]
      }
    },
    data() {
      return {
        fromRoute: null
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.fromRoute = from;
      })
    },
    methods: {
      goBack(event, fallback) {
        if (event) {
          event.preventDefault()
        }
        if (this.fromRoute == null || !this.fromRoute.name) {
          this.$router.push(fallback);
        } else {
          this.$router.back();
        }
      }
    },
  };
</script>
